<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('school.academic.setup.program.grade.grade') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('school.academic.setup.program.grade.grade'),
            href: '/grades'
          },
          {
            text: $t('school.academic.setup.program.grade.create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-5">
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label">
                      {{
                        $t('school.academic.setup.program.grade.main_program')
                      }}
                      <i
                        class="fas fa-question-circle"
                        v-tooltip="
                          $t(
                            'school.academic.setup.program.grade.select_main_program_to_filter_sub_program'
                          )
                        "
                      ></i>
                      <i class="fas fa-spinner spin" v-if="ready_fetch"></i>
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model="model.acp_id"
                        @change="onMainProgramChange(model.acp_id)"
                      >
                        <option value>--Select--</option>
                        <option
                          v-for="(main, index) in main_programs"
                          :key="index"
                          :value="main.acp_id"
                        >
                          {{ main.acp_name_foreign }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label">
                      {{
                        $t('school.academic.setup.program.grade.sub_program')
                      }}
                      <i
                        class="fas fa-question-circle"
                        v-tooltip="
                          $t(
                            'school.academic.setup.program.grade.select_sub_program_to_filter_level'
                          )
                        "
                      ></i>
                      <i class="fas fa-spinner spin" v-if="fetch_sub"></i>
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model="model.acps_id"
                        @change="onSubProgramChange(model.acps_id)"
                      >
                        <option value>--selec--</option>
                        <option
                          v-for="(sub, index) in sub_programs"
                          :key="index"
                          :value="sub.acps_id"
                        >
                          {{ sub.acps_name_foreign }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{ $t('school.academic.setup.program.grade.level') }}
                      <i class="fas fa-spinner spin" v-if="fetch_level"></i>
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('level_id') }"
                        v-model.number="model.level_id"
                        @change="getGradeBaseOnMainProgram"
                      >
                        <option value>--selec--</option>
                        <option
                          v-for="(level, index) in levels"
                          :key="index"
                          :value="level.level_id"
                        >
                          {{ level.level_name_foreign }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('level_id')"
                      >
                        {{ errors.first('level_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label">
                      {{ $t('school.academic.setup.program.grade.name_kh') }}
                    </label>
                    <div class="col-md-8">
                      <input
                        type="text"
                        v-model.trim="model.grade_name_native"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.has('grade_name_native')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grade_name_native')"
                      >
                        {{ errors.first('grade_name_native') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">{{
                      $t('school.academic.setup.program.grade.name_en')
                    }}</label>
                    <div class="col-md-8">
                      <input
                        type="text"
                        v-model.trim="model.grade_name_foreign"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.has('grade_name_foreign')
                        }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grade_name_foreign')"
                      >
                        {{ errors.first('grade_name_foreign') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{
                        $t('school.academic.setup.program.grade.abbreviation')
                      }}
                    </label>
                    <div class="col-md-8">
                      <input
                        type="text"
                        v-model.trim="model.grade_abbr"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('grade_abbr') }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grade_abbr')"
                      >
                        {{ errors.first('grade_abbr') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-7">
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{
                        $t('school.academic.setup.program.grade.grade_order')
                      }}
                    </label>
                    <div class="col-md-8">
                      <input
                        type="number"
                        v-model.number="model.grade_order"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('grade_order') }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('grade_order')"
                      >
                        {{ errors.first('grade_order') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label">
                      {{ $t('school.academic.setup.program.grade.next_grade') }}
                      <i
                        class="fas fa-spinner spin"
                        v-if="fetch_next_grade"
                      ></i>
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model.number="model.next_grade_id"
                      >
                        <option value>{{ $t('select') }}</option>
                        <option
                          v-for="(grade, index) in next_grades"
                          :key="index"
                          :value="grade.grade_id"
                        >
                          {{ grade.grade_name_foreign }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{
                        $t('school.academic.setup.program.grade.scoring_type')
                      }}
                    </label>
                    <div class="col-md-2">
                      <select
                        class="form-control"
                        v-model.number="model.score_type"
                        :class="{ 'is-invalid': errors.has('score_type') }"
                        @change="() => (model.sc_bas_id = null)"
                      >
                        <option value>--selec--</option>
                        <option value="1">Numbering</option>
                        <option value="2">Grading</option>
                        <option value="3">Rating</option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('score_type')"
                      >
                        {{ errors.first('score_type') }}
                      </div>
                    </div>

                    <label class="col-md-2 col-form-label">
                      {{
                        $t('school.academic.setup.program.grade.ignoreCycle')
                      }}
                    </label>
                    <div class="col-md-4">
                      <a-select
                        v-model="model.ignore_scoring_on_cycle"
                        mode="multiple"
                        :maxTagTextLength="10"
                        :maxTagCount="1"
                        :options="ignoreCycles"
                        class="ts-w-full ts-text-xs"
                      ></a-select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('ignore_scoring_on_cycle')"
                      >
                        {{ errors.first('ignore_scoring_on_cycle') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{
                        $t('school.academic.setup.program.grade.monthlyScore')
                      }}
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model.number="model.monthly_score_sc_bas_id"
                        :class="{
                          'is-invalid': errors.has('monthly_score_sc_bas_id')
                        }"
                      >
                        <option value>{{ $t('select') }}</option>
                        <option :value="1">Item Base</option>
                        <option :value="2">Subject Base</option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('monthly_score_sc_bas_id')"
                      >
                        {{ errors.first('monthly_score_sc_bas_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label required">
                      {{
                        $t('school.academic.setup.program.grade.semesterScore')
                      }}
                    </label>
                    <div class="col-md-8">
                      <select
                        class="form-control"
                        v-model.number="model.semester_score_sc_bas_id"
                        :class="{
                          'is-invalid': errors.has('semester_score_sc_bas_id')
                        }"
                      >
                        <option value>{{ $t('select') }}</option>
                        <option :value="1">Item Base</option>
                        <option :value="2">Subject Base</option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('semester_score_sc_bas_id')"
                      >
                        {{ errors.first('semester_score_sc_bas_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label">
                      {{
                        $t(
                          'school.academic.setup.program.grade.ignoreRatingCycle'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <a-select
                        v-model="model.enable_rating_on_cycle"
                        mode="multiple"
                        :maxTagTextLength="10"
                        :maxTagCount="1"
                        :options="ignoreCycles"
                        class="ts-w-full ts-text-xs"
                      ></a-select>
                    </div>
                  </div>
                  <div class="row form-group m-b-15">
                    <label class="col-md-4 col-form-label"></label>
                    <ts-checkbox v-model="model.attendance_by_subject">
                      {{
                        $t(
                          'school.academic.setup.program.grade.attendance_by_subject'
                        )
                      }}
                    </ts-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <h5 class="section-divider-underline">
                  {{ $t('school.academic.setup.program.grade.subjects') }}
                </h5>
                <div id="subject-list">
                  <p
                    class="text-center"
                    v-if="subjects.length == 0 && !fetch_subject"
                  >
                    <small>
                      <i>
                        {{
                          $t(
                            'school.academic.setup.program.grade.display_subject_lists'
                          )
                        }}
                      </i>
                    </small>
                  </p>
                  <p class="text-center" v-if="fetch_subject">
                    <i class="fas fa-spinner spin"></i> Loading...
                  </p>
                  <ul v-if="subjects.length">
                    <li v-for="(subject, index) in subjects" :key="index">
                      <ts-checkbox
                        v-model="model.subject_list"
                        :value="subject.subject_id"
                        >{{
                          subject.subject_name_foreign +
                            (subject.subject_code
                              ? ' | ' + subject.subject_code
                              : '')
                        }}</ts-checkbox
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div class="form-group">
                <div
                  class="ts-flex ts-justify-between section-divider-underline"
                >
                  <h5 class="section-divider">
                    {{
                      $t(
                        'school.academic.setup.program.grade.academicCoreProgramTitle'
                      )
                    }}
                  </h5>
                  <a
                    href="#"
                    v-tooltip="$t('add')"
                    class="mr-2 text-primary"
                    @click.prevent="createForm()"
                  >
                    <i class="fas fa-plus"></i>
                  </a>
                </div>

                <div>
                  <p
                    class="text-center"
                    v-if="model.core_pro_list.length == []"
                  >
                    <small>
                      <i>
                        {{
                          $t(
                            'school.academic.setup.program.grade.displayCoreProgramLists'
                          )
                        }}
                      </i>
                    </small>
                  </p>
                  <div
                    style="max-height: 25vh; height: 25vh"
                    class="ts-overflow-y-scroll"
                  >
                    <table
                      class="ts-w-full ts-mb-5"
                      v-if="model.core_pro_list.length != 0"
                    >
                      <thead>
                        <tr
                          class="
                            ts-uppercase
                            ts-bg-gray-200
                            ts-h-10
                            ts-sticky
                            ts-top-0
                          "
                        >
                          <th
                            class="ts-whitespace-no-wrap ts-pl-2"
                            style="width: 40%"
                          >
                            {{
                              $t(
                                'school.academic.setup.program.grade.academicCoreProgramNameEN'
                              )
                            }}
                          </th>
                          <th class="ts-whitespace-no-wrap" style="width: 40%">
                            {{
                              $t(
                                'school.academic.setup.program.grade.academicCoreProgramNameKH'
                              )
                            }}
                          </th>
                          <th style="width: 10%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="
                            ts-cursor-pointer
                            hover:ts-bg-gray-300
                            ts-w-full ts-h-10
                          "
                          v-for="(core, index) in model.core_pro_list"
                          :key="index"
                        >
                          <td
                            class="ts-whitespace-no-wrap ts-text-left ts-pl-2"
                          >
                            {{ core.core_program_en }}
                          </td>
                          <td class="ts-whitespace-no-wrap ts-text-left">
                            {{ core.core_program_kh }}
                          </td>
                          <td
                            class="
                              ts-whitespace-no-wrap
                              text-danger
                              ts-text-center
                            "
                          >
                            <a
                              href="#"
                              v-tooltip="$t('delete')"
                              @click.prevent="remove(core)"
                            >
                              <i class="fas fa-trash"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <ts-button
                class="mr-2"
                @click="$router.push({ name: 'grade' })"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button
                outline
                color="primary"
                class="mr-2"
                :waiting="waiting_save_new"
                @click.prevent="saveAddNew"
                >{{ $t('save_add_new') }}</ts-button
              >
              <ts-button
                color="primary"
                :waiting="waiting_save"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import FormComponent from './core-program.vue'

export default {
  name: 'grade-create',
  data () {
    return {
      model: {
        acp_id: '',
        acps_id: '',
        level_id: '',
        grade_name_native: '',
        grade_name_foreign: '',
        grade_abbr: '',
        grade_order: '',
        next_grade_id: '',
        attendance_by_subject: false,
        subject_list: [],
        score_type: 1,
        monthly_score_sc_bas_id: '',
        semester_score_sc_bas_id: '',
        core_pro_list: [],
        ignore_scoring_on_cycle: [],
        enable_rating_on_cycle: []
      },
      sub_programs: [],
      levels: [],
      subjects: [],
      next_grades: [],
      ready_fetch: false,
      fetch_sub: false,
      fetch_level: false,
      fetch_subject: false,
      fetch_next_grade: false,
      waiting_save: false,
      waiting_save_new: false,
      errors: new Errors()
    }
  },
  async created () {
    await this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('grade', ['main_programs', 'core_programs']),
    ignoreCycles () {
      return this.$store.state.grade.ignore_cycle.map(el => ({
        value: el.scoring_cycle_id,
        label: el.scoring_cycle_name
      }))
    }
  },
  methods: {
    createForm () {
      this.$modal.show(
        FormComponent,
        {
          value: this.model
        },
        {
          height: 'auto',
          width: '35%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
        // {
        //   'before-close': this.fetchResourceBeforeCreate,
        // }
      )
    },
    remove (core) {
      this.core_programs.push({
        core_pro_id: core.core_pro_id,
        core_program_en: core.core_program_en,
        core_program_kh: core.core_program_kh
      })

      var index = this.model.core_pro_list.indexOf(
        this.model.core_pro_list.find(e => e.core_pro_id == core.core_pro_id)
      )
      this.model.core_pro_list.splice(index, 1)
    },
    fetchResourceBeforeCreate () {
      this.ready_fetch = true
      this.$store
        .dispatch('grade/dataBeforeCreate')
        .then(response => {
          this.ready_fetch = false
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    onMainProgramChange (acp_id) {
      this.model.acps_id = ''
      this.model.level_id = ''
      this.subjects = this.levels = this.next_grades = this.model.subject_list = []
      this.fetch_sub = true
      this.$store
        .dispatch('grade/getSubProgram', acp_id ? acp_id : 0)
        .then(response => {
          this.fetch_sub = false
          this.sub_programs = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_sub = false
        })
    },
    async onSubProgramChange (acps_id) {
      this.model.level_id = ''
      this.subjects = this.levels = this.next_grades = this.model.subject_list = []
      this.fetch_level = true
      this.fetch_subject = true
      let level = await this.$store.dispatch(
        'grade/getLevel',
        acps_id ? acps_id : 0
      )
      this.levels = level.data
      this.fetch_level = false
      let subject = await this.$store.dispatch('grade/getSubject', {
        acps_id: this.model.acps_id ? this.model.acps_id : 0,
        acp_id: this.model.acp_id
      })
      this.subjects = subject.data
      this.fetch_subject = false
    },

    async getGradeBaseOnMainProgram () {
      if (!this.model.acp_id) {
        return
      }
      this.model.next_grade_id = ''
      this.fetch_next_grade = true
      this.$store
        .dispatch('grade/getGrade', this.model.acp_id)
        .then(response => {
          this.next_grades = response.data
          this.fetch_next_grade = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetch_next_grade = false
        })
    },
    store () {
      this.errors = new Errors()
      this.waiting_save = true
      this.$store
        .dispatch('grade/store', this.model)
        .then(response => {
          this.waiting_save = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'grade' })
        })
        .catch(error => {
          this.waiting_save = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    saveAddNew () {
      this.errors = new Errors()
      this.waiting_save_new = true
      this.$store
        .dispatch('grade/store', this.model)
        .then(response => {
          this.waiting_save_new = false
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.waiting_save_new = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting_save_new = false
        })
    },
    clearInput () {
      this.model = {
        acp_id: '',
        acps_id: '',
        level_id: '',
        grade_name_native: '',
        grade_name_foreign: '',
        grade_abbr: '',
        grade_order: '',
        next_grade_id: '',
        attendance_by_subject: false,
        subject_list: [],
        score_type: 1,
        sc_bas_id: null
      }
      this.sub_programs = []
      this.levels = []
      this.subjects = []
      this.next_grades = []
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('grade/RESET_STATE')
    }
    next()
  }
}
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  border-bottom: 1px solid #eee;
  font-size: 12px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
#subject-list {
  padding-left: 20px;
  max-height: 180px;
  overflow-x: scroll;
}
#subject-list ul li {
  padding-left: 7px;
}
</style>
